import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

const insaneSpacing = getThemeByPath('spacings.insane');

export const Animation = styled.div`
  @keyframes opacity-fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes opacity-fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes padding-left-fade-in {
    0% {
      transform: translateX(-${insaneSpacing}px);
    }
    100% {
      transform: translateX(0px);
    }
  }

  @keyframes padding-left-fade-out {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(-${insaneSpacing}px);
    }
  }

  @keyframes padding-right-fade-in {
    0% {
      transform: translateX(${insaneSpacing}px);
    }
    100% {
      transform: translateX(0px);
    }
  }

  @keyframes padding-right-fade-out {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(${insaneSpacing}px);
    }
  }
`;
